import { KoffieDienstStatus } from "@/entities/dossier-overzicht";
import { useId } from "react";

function Clock() {
    return (
        <path
            d="M17 10C20.8587 10 24 13.1413 24 17C24 20.8587 20.8587 24 17 24C13.1413 24 10 20.8587 10 17C10 13.1413 13.1413 10 17 10ZM17 12.5547C16.5187 12.5547 16.125 12.9484 16.125 13.4297V17.3672L18.1641 19.4062C18.339 19.5723 18.5578 19.6602 18.7852 19.6602C19.0125 19.6601 19.2313 19.5811 19.4062 19.4062C19.7475 19.065 19.7475 18.5131 19.4062 18.1719L17.875 16.6406V13.4297C17.875 12.9484 17.4812 12.5547 17 12.5547Z"
            className="text-content-info"
            fill="currentColor"
        />
    );
}

function Check() {
    return (
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 17C10 13.13 13.13 10 17 10C20.87 10 24 13.13 24 17C24 20.87 20.87 24 17 24C13.13 24 10 20.87 10 17ZM16.13 20.2L20.55 15.39H20.56C20.84 15.08 20.82 14.61 20.51 14.33C20.2 14.05 19.73 14.07 19.45 14.38L16.09 18.04L14.53 16.48C14.24 16.19 13.76 16.19 13.47 16.48C13.18 16.77 13.18 17.25 13.47 17.54L16.13 20.2Z"
            className="text-content-success"
            fill="currentColor"
        />
    );
}

function OrangeClock() {
    return (
        <path
            d="M17 10C20.8587 10 24 13.1413 24 17C24 20.8587 20.8587 24 17 24C13.1413 24 10 20.8587 10 17C10 13.1413 13.1413 10 17 10ZM17 12.5547C16.5187 12.5547 16.125 12.9484 16.125 13.4297V17.3672L18.1641 19.4062C18.339 19.5723 18.5578 19.6602 18.7852 19.6602C19.0125 19.6601 19.2313 19.5811 19.4062 19.4062C19.7475 19.065 19.7475 18.5131 19.4062 18.1719L17.875 16.6406V13.4297C17.875 12.9484 17.4812 12.5547 17 12.5547Z"
            className="text-accent-orange-default"
            fill="currentColor"
        />
    );
}

function Minus() {
    return (
        <path
            d="M17 10C20.8598 10.0001 23.9999 13.1402 24 17C24 20.8599 20.8599 23.9999 17 24C13.14 24 10 20.86 10 17C10.0001 13.1401 13.1401 10 17 10ZM13.5 16C13.2239 16 13 16.2239 13 16.5V17.5C13 17.7761 13.2239 18 13.5 18H20.5C20.7761 18 21 17.7761 21 17.5V16.5C21 16.2239 20.7761 16 20.5 16H13.5Z"
            className="text-chart-neutral"
            fill="currentColor"
        />
    );
}

function CofeeMug() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                opacity="0.5"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.00349 4.08412C6.00118 4.05639 6 4.02833 6 4C6 2.89543 6.89543 2 8 2H16C17.1046 2 18 2.89543 18 4C18 4.02833 17.9988 4.05639 17.9965 4.08413C18.5809 4.28906 19 4.84559 19 5.5C19 6.17763 18.5507 6.75032 17.9337 6.93635C17.9363 6.97777 17.9363 7.01983 17.9336 7.06238L17.0586 21.0624C17.0257 21.5894 16.5887 22 16.0606 22H7.93949C7.41143 22 6.97438 21.5894 6.94144 21.0624L6.06644 7.06238C6.06378 7.01984 6.06382 6.97778 6.06639 6.93637C5.44938 6.75037 5 6.17766 5 5.5C5 4.84559 5.41907 4.28905 6.00349 4.08412ZM7 4C7 3.44772 7.44772 3 8 3H16C16.5523 3 17 3.44772 17 4H7ZM18 5.5C18 5.22386 17.7761 5 17.5 5H6.5C6.22386 5 6 5.22386 6 5.5C6 5.77614 6.22386 6 6.5 6H17.5C17.7761 6 18 5.77614 18 5.5ZM7.93949 21L7.75199 18H13V17H7.68949L7.25199 10H14V9H7.18949L7.06449 7L16.9356 7L16.8106 9H16V10H16.7481L16.3106 17H15V18H16.2481L16.0606 21H7.93949Z"
                className="text-content-emphasis"
                fill="currentColor"
            />
        </svg>
    );
}

type KoffieStatus = {
    variant: KoffieDienstStatus;
};

export function KoffieStatus({ variant }: KoffieStatus) {
    const maskId = useId();

    if (variant === "Aangevraagd") {
        return <CofeeMug />;
    }

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id={maskId} style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <path d="M24 0H0V24H9V12L12 9H24V0Z" fill="#D9D9D9" />
            </mask>
            <g mask={`url(#${maskId})`}>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.00349 4.08412C6.00118 4.05639 6 4.02833 6 4C6 2.89543 6.89543 2 8 2H16C17.1046 2 18 2.89543 18 4C18 4.02833 17.9988 4.05639 17.9965 4.08413C18.5809 4.28906 19 4.84559 19 5.5C19 6.17763 18.5507 6.75032 17.9337 6.93635C17.9363 6.97777 17.9363 7.01983 17.9336 7.06238L17.0586 21.0624C17.0257 21.5894 16.5887 22 16.0606 22H7.93949C7.41143 22 6.97438 21.5894 6.94144 21.0624L6.06644 7.06238C6.06378 7.01984 6.06382 6.97778 6.06639 6.93637C5.44938 6.75037 5 6.17766 5 5.5C5 4.84559 5.41907 4.28905 6.00349 4.08412ZM7 4C7 3.44772 7.44772 3 8 3H16C16.5523 3 17 3.44772 17 4H7ZM18 5.5C18 5.22386 17.7761 5 17.5 5H6.5C6.22386 5 6 5.22386 6 5.5C6 5.77614 6.22386 6 6.5 6H17.5C17.7761 6 18 5.77614 18 5.5ZM7.93949 21L7.75199 18H13V17H7.68949L7.25199 10H14V9H7.18949L7.06449 7L16.9356 7L16.8106 9H16V10H16.7481L16.3106 17H15V18H16.2481L16.0606 21H7.93949Z"
                    className="text-content-emphasis"
                    fill="currentColor"
                />
            </g>
            {variant === "Besteld" && <Clock />}
            {variant === "Actief" && <Check />}
            {variant === "StopAangevraagd" && <OrangeClock />}
            {(variant === "Gestopt" || variant === "GaatNietLeveren") && <Minus />}
        </svg>
    );
}
